(ns ductile.service.code)

(def assign-contract "Auftrag zuweisen")

(def ars-id "ARS-ID")
(def record-transport-info "Record Transport Info")
(def entry-inspection "Eingangsinspektion")
(def check-hv-battery "Hochvoltbatterie prüfen")
(def charge-hv-battery "Hochvoltbatterie laden")
(def record-special-equipment "Spezielle Ausstattung erfassen")
(def own-wheels-parking "Own wheels parking")
(def entry "Eingang")

(def exit "Ausgang")

(def compound "Compound")

(def parking "Parken")

(def räderhändling+zwischenlagerung "Räderhandling inkl. Zwischenlagerung")
(def räder-einlegen+zurrgurte "Räder einlegen inkl. Zurrgurte")

(def entry-correction "Eingangskorrektur")

(def change-wheels "Räderwechsel")

(def awaiting-wheel-set "Radsatz in Empfang nehmen")
(def request-wheel-set "Radsatz anfordern")
(def photo-uninstalled-wheel-set "Fotodokumentation demontierter Radsatz")
(def photo-packed-wheel-set "Fotodokumentation verpackter Radsatz")
(def provide-packed-wheel-set-for-pickup "Bereitstellung verpackter Radsatz zur Abholung")

(def second-provisioning-of-fahrzeug-for-wheel-change "2. Bereitstellung für Räderwechsel")

(def wheel-set-change-announcement "Avise Räderwechsel")
(def tracker-installation-announcement "Avise Trackerverbau")

(def codes
  {:service.id/import-fahrzeug ["Import announced vehicle" "Fahrzeugavise" "Importazione vettura"]

   :service.id/contract-assignment ["Contract Assignment" "Vertragszuweisung" "Assign Contract"]
   :service.id/call-off ["Call-off" "Lagerabruf" "Call-off"]
   :service.id/call-off-update ["Call-off update" "Aktualisierter Lagerabruf" "Aggiornamento Call-off"]

   ;;;

   :service.id/arrival-scan ["Arrival scan" "Ankunftsscan" "Scansione iniziale"]
   :service.id/train-unloading ["Train unloading" "Zugentladung" "Scarico treno"]
   :service.id/fpr-inspection ["FPR inspection" "FPR Inspektion" "Ispezione FPR"]
   :service.id/fpr-entry ["FPR entry" "FPR-Eingang" "Ingresso FPR"]
   :service.id/vin-check ["VIN check" "FIN Kontrolle" "Controllo VIN"]
   :service.id/vin-correction ["VIN correction" "FIN-Korrektur" "Correzione VIN"]
   :service.id/ars-id ["ARS-ID" "ARS-ID" "ARS-ID"]
   :service.id/record-transport-data ["Record transport data" "Erfassung Transportdaten" "Registrazione dati trasporto"]
   :service.id/classification ["Classification" "Klassifizierung" "Classificazione"]
   :service.id/abort-entry-process ["Abort entry process" "Abbruch Eingangsprozess" "Interruzione ingresso"]
   :service.id/entry-inspection ["Entry inspection" "Eingangsinspektion" "Ispezione all'ingresso"]
   :service.id/confirm-entry ["Confirm entry" "Eingang bestätigen" "Conferma Ingresso"]
   :service.id/storage ["Storage" "Lager" "Storage"]
   :service.id/quick-turnaround ["Quick turnaround" "Schnelldreher verbringen" "Transito rapido"]
   :service.id/prepare-for-transport ["Prepare for transport" "Bereitstellung Transport" "Preparazione per il trasporto"]
   :service.id/clear-from-loading-area ["Clear from loading area" "Ladebereich freigeben" "Rimozione da area di carico"]
   :service.id/reparking ["Reparking" "Umparken" "Riposizionamento"]
   :service.id/entry-correction ["Entry correction" "Eingangskorrektur" "Correzione ingresso"]
   :service.id/data-correction ["Data correction" "Datenkorrektur" "Correzione dati"]
   :service.id/upload-attachment ["Upload Attachment" "Dateianhang hochladen" "Caricamento allegato"]
   :service.id/remove-from-load ["Remove from load" "Vom Ausgangstransport entfernen" "Rimozione dal carico"]
   :service.id/approval-for-external-workshop ["Approval for external workshop" "Freigabe für externe Werkstatt" "Approvazione per lavorazione esterna"]

   :service.id/hv-battery-check ["HV battery check" "Hochvoltbatterie prüfen" "Controllo batteria HV"]
   :service.id/battery-check ["12V battery check" "Batterie 12V prüfen" "Controllo Batteria 12V"]
   ;;FIXME: These are NOT the same!!
   :service.id/hv-battery-charge ["HV battery charge" "Hochvoltbatterie laden" "Caricamento batteria HV"]
   :service.id/battery-charge ["12V battery charge" "Batterie 12V laden" "Caricamento batteria"]
   :service.id/tire-pressure-adjustment ["Tire pressure adjustment" "Reifendruck anpassen" "Pressione pneumatici"]
   :service.id/fueling ["Fueling" "Tanken" "Rifornimento"]})

(def code->id
  (into {}
        (mapcat (fn [[id cds]]
                  (map (juxt identity (constantly id)) cds)))
        codes))

(def id->country-code->service-code (update-vals codes #(zipmap ["ENG" "DEU" "ITA"] %)))
